;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        id: Number,
        currentAmount: {
            default: 1
        },
        maxValue: {
            default: Infinity
        },
        updateAmount: Function,
        type: {
            type: String,
            default: 'default'
        }
    },
    data: function data() {
        return {
            amount: Number(this.currentAmount) || 1
        };
    },

    watch: {
        currentAmount: function currentAmount(amount) {
            this.amount = amount;
        }
    },
    methods: {
        update: function update(type, amount) {
            if (type === 'decrease' || type === 'increase') {
                this[type]();
            } else {
                this.amount = amount ? Number(amount) : Number(type.target.value);
            }

            if (this.validate() && this.updateAmount) {
                this.updateAmount({ amount: this.amount });
            }
        },
        decrease: function decrease() {
            this.amount = this.amount - 1;
        },
        increase: function increase() {
            this.amount = this.amount + 1;
        },
        validate: function validate() {
            if (this.amount < 1 || isNaN(this.amount)) {
                this.amount = 1;
                return false;
            }

            if (this.amount > this.maxValue || isNaN(this.amount)) {
                this.amount = this.maxValue;
                return false;
            }

            return true;
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter",class:("is-" + _vm.type)},[(_vm.type === "alt")?[_c('input',{staticClass:"counter__field",attrs:{"type":"text","name":"count","readonly":"readonly","tabindex":"-1"},domProps:{"value":_vm.amount}}),_c('div',{staticClass:"counter__buttons"},[_c('button',{staticClass:"counter__button is-add",attrs:{"aria-label":"Добавить","type":"button"},on:{"click":function($event){return _vm.update("increase")}}},[_c('svg',{staticClass:"counter__icon"},[_c('use',{attrs:{"xlink:href":"/img/sprite.svg#add"}})])]),_c('button',{staticClass:"counter__button is-remove",attrs:{"aria-label":"Убрать","type":"button","readonly":"readonly"},on:{"click":function($event){return _vm.update("decrease")}}},[_c('svg',{staticClass:"counter__icon"},[_c('use',{attrs:{"xlink:href":"/img/sprite.svg#remove"}})])])])]:[_c('button',{staticClass:"counter__button is-remove",attrs:{"aria-label":"Убрать","type":"button","readonly":"readonly"},on:{"click":function($event){return _vm.update("decrease")}}},[_c('svg',{staticClass:"counter__icon"},[_c('use',{attrs:{"xlink:href":"/img/sprite.svg#remove"}})])]),_c('input',{staticClass:"counter__field",attrs:{"type":"text","name":"count","readonly":"readonly","tabindex":"-1"},domProps:{"value":_vm.amount}}),_c('button',{staticClass:"counter__button is-add",attrs:{"aria-label":"Добавить","type":"button"},on:{"click":function($event){return _vm.update("increase")}}},[_c('svg',{staticClass:"counter__icon"},[_c('use',{attrs:{"xlink:href":"/img/sprite.svg#add"}})])])]],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3fcb1289", __vue__options__)
  } else {
    hotAPI.reload("data-v-3fcb1289", __vue__options__)
  }
})()}